import RadioListComponent from '72cms-ui/components/form-elements/RadioListComponent';
import CommandPanelComponent from '72cms-ui/components/dashboard-elements/CommandPanelComponent';

export default {
    deletable: false,
    sections: ['contact', 'location', 'technical', 'social', 'hours', 'google', 'maintenance'],
    groups: {
        recaptcha: {
            component: {
                template: '<div class="form-row"><slot name="recaptcha_site_key" /><slot name="recaptcha_server_key" /></div>',
            }
        },
        analytics: {
            component: {
                template: '<div class="form-row"><slot name="analytics_tracking_type" /></div>',
            }
        },
        analytics_key: {
            component: {
                template: '<div class="form-row"><slot name="google_analytics" /><slot name="google_tag_manager" /></div>',
            }
        },
        setting_address: {
            component: {
                template: `<div class="form-row">
                    <div class="col-md-6">
                        <slot name="address" />
                        <slot name="street" />
                        <slot name="suburb" />
                        <slot name="city" />
                        <slot name="country" />
                        <slot name="postcode" />
                    </div>
                    <div class="col-md-6">
                        <slot name="location" />
                    </div>
                </div>`
            }
        },
    },
    toolbar: ['edit', 'active', 'delete'],
    fields: {
        site_version: {
            section: 'details',
            position: 0,
        },
        company_name: {
            section: 'contact',
            position: 1,
        },
        contact_address: {
            section: 'contact',
            position: 2,
        },
        postal_address: {
            section: 'contact',
            position: 3,
        },
        phone: {
            section: 'contact',
            position: 4,
        },
        contact_email: {
            section: 'contact',
            position: 5,
        },

        address: {
            section: 'location',
            group: 'setting_address',
            position: 0,
        },
        street: {
            section: 'location',
            group: 'setting_address',
            position: 1,
            listener: function (entry, entries, $form) {
                if (!entry.newValue) return;
                if (entry.name == 'address' && typeof(entry.newValue) == 'object') {
                    const { address_components: components } = entry.newValue;
                    let streetNumber = components.find(component => component.types.indexOf('street_number') >= 0);
                    streetNumber = streetNumber ? streetNumber.long_name : null;
                    let street = components.find(component => component.types.indexOf('route') >= 0);
                    street = street ? street.long_name : '';

                    if (streetNumber || street) {
                        this.value = `${streetNumber} ${street}`
                    } else {
                        this.value = '';
                    }
                }
            },
        },
        suburb: {
            section: 'location',
            group: 'setting_address',
            position: 2,
            listener: function (entry, entries, $form) {
                if (!entry.newValue) return;
                if (entry.name == 'address' && typeof(entry.newValue) == 'object') {
                    const { address_components: components } = entry.newValue;
                    let subLocality = components.find(component => component.types.indexOf('sublocality') >= 0);
                    subLocality = subLocality ? subLocality.long_name : '';

                    this.value = subLocality;
                }
            },
        },
        city: {
            section: 'location',
            group: 'setting_address',
            position: 3,
            listener: function (entry, entries, $form) {
                if (!entry.newValue) return;
                if (entry.name == 'address' && typeof(entry.newValue) == 'object') {
                    const { address_components: components } = entry.newValue;
                    let locality = components.find(component => component.types.indexOf('locality') >= 0);
                    locality = locality ? locality.long_name : '';

                    this.value = locality;
                }
            },
        },
        country: {
            section: 'location',
            group: 'setting_address',
            position: 4,
            listener: function (entry, entries, $form) {
                if (!entry.newValue) return;
                if (entry.name == 'address' && typeof(entry.newValue) == 'object') {
                    const { address_components: components } = entry.newValue;
                    let country = components.find(component => component.types.indexOf('country') >= 0);
                    country = country ? country.long_name : null;

                    if (country) {
                        this.value = country;
                    }

                }
            },
        },
        location: {
            section: 'location',
            group: 'setting_address',
            position: 5,
            listener: function (entry, entries, $form) {
                if (!entry.newValue) return;
                if (entry.name == 'address' && typeof(entry.newValue) == 'object') {
                    const { geometry } = entry.newValue;
                    if (geometry && geometry.location) {
                        const lat = geometry.location.lat() || null;
                        const lng = geometry.location.lng() || null;
                        this.value = (lat && lng) ? `${lat},${lng}` : '';
                    }
                }
            },
        },

        website: {
            section: 'technical',
            position: 0,
        },
        enquiry_email: {
            section: 'technical',
            position: 1,
        },
        order_email: {
            section: 'technical',
            label: 'Measure & Quote email',
            position: 2,
        },
        from_email: {
            section: 'technical',
            position: 3,
        },

        facebook: {
            section: 'social',
            position: 0,
        },
       
        instagram: {
            section: 'social',
            position: 2,
        },
        dribbble: {
            section: 'social',
            position: 3,
        },
        behance: {
            section: 'social',
            position: 4,
        },

        monday_hours: {
            section: 'hours',
            position: 0,
        },
        tuesday_hours: {
            section: 'hours',
            position: 1,
        },
        wednesday_hours: {
            section: 'hours',
            position: 2,
        },
        thursday_hours: {
            section: 'hours',
            position: 3,
        },
        friday_hours: {
            section: 'hours',
            position: 4,
        },
        saturday_hours: {
            section: 'hours',
            position: 5,
        },
        sunday_hours: {
            section: 'hours',
            position: 6,
        },

        recaptcha_site_key: {
            section: 'google',
            group: 'recaptcha',
            cssClass: 'col-md-6',
            description: 'Use this in the HTML code your site serves to users.',
            position: 0,
        },
        recaptcha_server_key: {
            section: 'google',
            group: 'recaptcha',
            cssClass: 'col-md-6',
            description: 'Use this for communication between your site and Google.',
            position: 1,
        },
        google_map_key: {
            section: 'google',
            description: '',
            position: 2,
        },
        analytics_tracking_type: {
            section: 'google',
            position: 3,
            component: RadioListComponent,
            group: 'analytics',
            cssClass: 'col-md-6',
            values: [
                { id: 'Tag Manager', description: 'Use Google Tag Manager' },
                { id: 'Analytics Code', description: 'Use Google Analytics Code' },
            ],
        },
        google_analytics: {
            section: 'google',
            position: 4,
            group: 'analytics_key',
            cssClass: 'col-md-6',
            disabled: function (value, schema, data) {
                return data.analytics_tracking_type == 'Tag Manager';
            },
            listener: function (entry, entries, $form) {
                const value = entry.newValue || entry.value;
                if (entry.name == 'analytics_tracking_type') {
                    if (value == 'Analytics Code') {
                        this.disabled = false;
                    } else {
                        this.disabled = true;
                    }
                }
            },
        },
        google_tag_manager: {
            section: 'google',
            position: 5,
            group: 'analytics_key',
            cssClass: 'col-md-6',
            disabled: function (value, schema, data) {
                return data.analytics_tracking_type != 'Tag Manager';
            },
            listener: function (entry, entries, $form) {
                const value = entry.newValue || entry.value;
                if (entry.name == 'analytics_tracking_type') {
                    if (value == 'Tag Manager') {
                        this.disabled = false;
                    } else {
                        this.disabled = true;
                    }
                }
            },
        },

        command: {
            section: 'maintenance',
            position: 0,
            component: CommandPanelComponent,
        },
    }
}



// WEBPACK FOOTER //
// ./resources/assets/cms/js/config/form.setting.js